import classNames from 'classnames'
import React, { FC } from 'react'

import s from './WixMobileContentWrapper.scss'

export const WixMobileContentWrapper: FC<{ className?: string }> = ({ children, className }) => {
  return <div className={classNames(s.wrapper, className)}>{children}</div>
}
